module.exports = __webpack_public_path__ + "img/icon-31.77e3112f.svg";